import * as Yup from 'yup';
import { reverseShape } from 'Helpers/index';
import { password } from 'Utils/validations';

const ResetPasswordFormSchema = Yup.object().shape(
  reverseShape({
    newPassword: password.required(),
    confirmNewPassword: Yup.string().oneOf([Yup.ref('newPassword'), null])
  })
)

export default ResetPasswordFormSchema;
